import CONSTANTS from 'utils/constants';
import _ from 'ckLodash';
import elementUtils from 'utils/elementUtils';
import guardUtils from 'utils/guardUtils';
import keyDownHandler from 'eventHandlers/keyDownHandler';
import selectionUtils from 'utils/selectionUtils';
import utils from 'utils/utils';

var SELECT_GUARD_BEFORE_COMMANDS = [
    'bold',
    'italic',
    'underline',
    'strike',
    'subscript',
    'superscript',
    'fontSize',
    'fontFamily',
    'letterSpacing',
    'textShadow',
    'wixLink',
    'wixUnlink',
    'unBold',
    'unItalic',
    'foreColorInline',
    'foreColorClass',
    'foreColor',
    'backColorInline',
    'backColorClass',
    'backColor'
];

function fixInheritFontClass(editor) {
    var elementsWithInheritClass = editor.editable().find('.inherit-font-size');
    for (var i = 0; i < elementsWithInheritClass.count(); i++) {
        var element = elementsWithInheritClass.getItem(i);
        if (!elementUtils.isWhiteSpace(element)) {
            element.removeClass('inherit-font-size');
        }
    }
}

function handleKeyDown(event) {
    event.sender.editor.WIX.isKeyDown = true;

    keyDownHandler.handleKeyDown(event);
}

function handleEmptyTextBlock(editor) {
    var startTextBlock = utils.getBlockParent(selectionUtils.getSelectedRange(editor).startPath());
    if (elementUtils.isElementTextEmpty(startTextBlock) && !guardUtils.hasGuard(startTextBlock)) {
        //todo - rename to createBookmark(editor, forceCreate)
        var bookmark = selectionUtils.createBookmark(editor);
        var refNode = bookmark && bookmark.startNode;
        if (refNode && refNode.getIndex()) {
            refNode = refNode.getParent().getChild(0);
        }
        guardUtils.insertGuard(editor, startTextBlock, refNode);
        selectionUtils.moveToBookmark(editor, bookmark);
    }
}

function removeHijackedWixGuards(editor) {
    var range = selectionUtils.getSelectedRange(editor);
    if (!range.collapsed) {
        return;
    }
    var blockParent = utils.getBlockParent(range.startPath());
    editor.WIX.hijackedWixGuards = _.filter(editor.WIX.hijackedWixGuards, function (val) {
        if (!editor.editable().contains(val.guard) || !editor.editable().contains(val.parentBlock)) {
            return false;
        }
        if (blockParent.equals(val.parentBlock)) {
            return true;
        }
        elementUtils.replaceElementByItsContents(val.guard);
        return false;
    });
}

function removeHijackedFillingChar(editor) {
    var range = selectionUtils.getSelectedRange(editor);
    if (!range.collapsed || range.startContainer.type !== CKEDITOR.NODE_TEXT) {
        return;
    }
    editor.WIX.hijackedFillingChars = _.filter(editor.WIX.hijackedFillingChars, function (val) {
        if (!editor.editable().contains(val)) {
            return false;
        }
        if (range.startContainer.equals(val)) {
            return true;
        }
        val.setText(val.getText().replace(new RegExp('[' + CONSTANTS.CK_GUARD + CONSTANTS.WIX_GUARD + ']', 'g'), ''));
        return false;
    });
}

function handleKeyUp(event) {
    event.sender.editor.WIX.isKeyDown = false;

    var editor = event.sender.editor;
    editor.undoManager.lock();
    removeHijackedFillingChar(editor);
    removeHijackedWixGuards(editor);
    fixInheritFontClass(editor);
    guardUtils.removeUneededGuards(editor);
    handleSelectAll(editor);
    handleEmptyTextBlock(editor);
    editor.undoManager.unlock();
    editor.fire('change');
}

function handleSelectAll(editor) {
    selectionUtils.fixSelectionOnBodyIfNeeded(editor);
}

function shouldSelectGuardBeforeCommandExec(evt) {
    return SELECT_GUARD_BEFORE_COMMANDS.indexOf(evt.data.name) >= 0;
}

function init(editor) {
    editor.on('contentDom', function () {
        editor.editable().on('keydown', handleKeyDown, null, null, -9999);
        editor.editable().on('keyup', handleKeyUp);
    });

    editor.on('beforeCommandExec', function (evt) {
        if (shouldSelectGuardBeforeCommandExec(evt)) {
            //todo - move to selection utils maybe call it - getSelectedStartBlock
            var startTextBlock = utils.getBlockParent(selectionUtils.getSelectedRange(editor).startPath());
            //if there are brs between cursor and guard then we dont need to select the guard and "avoid guard wrongly before styled text"
            if (!guardUtils.hasGuard(startTextBlock) || !selectionUtils.getSelectedRange(editor) ||
                selectionUtils.countBrTagsBeforeCursor(editor, startTextBlock) !== 0) {
                return;
            }
            guardUtils.expandSelectionToGuard(editor, startTextBlock);
        }
    });
}

export default {
    init: init
};
